"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestionOrder = exports.CONS = exports.PROS = exports.FOR = exports.REVIEW = exports.TITLE = void 0;

var _immutable = require("immutable");

// Note: these must match translation keys under ecosystemMarketplaceCore.reviews.responses
var TITLE = 'TITLE';
exports.TITLE = TITLE;
var REVIEW = 'REVIEW';
exports.REVIEW = REVIEW;
var FOR = 'FOR';
exports.FOR = FOR;
var PROS = 'PROS';
exports.PROS = PROS;
var CONS = 'CONS';
exports.CONS = CONS;
var QuestionOrder = (0, _immutable.List)([TITLE, REVIEW, FOR, PROS, CONS]);
exports.QuestionOrder = QuestionOrder;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/reviews/ReviewQuestions.js
// module id = 226
// module chunks = 209 210 211 212